import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import Navbar from '../../components/Features/Navbar';
import Footer from './../../components/Home/Footer'

import './../../styles/expert-co.css'

const SuiviClassique = () => {
  const [open, setOpen] = useState(true); // Dialog opens automatically on component mount
  const [acceptedGCU, setAcceptedGCU] = useState(false);

  useEffect(() => {
    document.title = 'Forfait Classique | Tsahal Connection';
  }, []);

  const handleAcceptGCU = () => {
    // Rediriger directement vers le lien Morning
    window.location.href = 'https://mrng.to/LARNpjDLdc';
  };



  return (
    <div>
      <Navbar />
      {/* Affichage du dialog de contrat */}
      {!acceptedGCU && (
        <div>
          <Dialog
            open={open}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                setOpen(false);
              }
            }} // Only allow dialog to close for reasons other than clicking outside or pressing escape
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="md"
            fullWidth
          >
            <DialogContent>
              <iframe
                src="https://1drv.ms/b/c/3d7204f3e39d5a05/UQQFWp3j8wRyIIA9tVQAAAAAALR7wrm1TqlWqkk"
                style={{ width: '100%', height: '500px', border: 'none' }}
                title="GCU Document"
              ></iframe>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleAcceptGCU}>Accepter le contrat</Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
      
      {/* Si l'utilisateur n'est pas encore arrivé sur cette page ou si le contrat n'est pas accepté */}
      {acceptedGCU && (
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <p>Redirection vers le paiement en cours...</p>
        </div>
      )}
    </div>
  );
};

export default SuiviClassique;
